<template>
  <div class="container-fluid">
    <div class="row">
      <!-- LEFT: PRODUCT LIST -->
      <div class="col-12 col-md-8">
        <!-- TOGGLE PILOT -->
        <div class="mb-3 text-center">
          <label style="cursor: pointer; font-weight: 600">
            <input type="checkbox" v-model="isPilot" />
          </label>
          Giá vùng thí điểm
        </div>

        <!-- PRODUCT GRID -->
        <div class="row g-3">
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-6"
            v-for="p in filteredProducts"
            :key="p.id"
          >
            <div
              class="product-box"
              :class="{ active: editingId === p.id }"
              @click="openDetail(p)"
            >
              <div class="img-box">
                <img :src="'https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=' +getImages(p)[0]" @error="onImgError" />
              </div>

              <div class="p-2">
                <div class="product-name">{{ p.name }}</div>

                <div class="price-box">
                  <template v-if="getPrice(p, 'BUY') && getPrice(p, 'RENT')">
                    <span class="price">
                      Thuê: {{ formatPrice(getPrice(p, "RENT")) }}
                    </span>
                    <span class="old-price">
                      Mua: {{ formatPrice(getPrice(p, "BUY")) }}
                    </span>
                  </template>

                  <template v-else-if="getPrice(p, 'BUY')">
                    <span class="old-price">
                      Mua: {{ formatPrice(getPrice(p, "BUY")) }}
                    </span>
                  </template>

                  <template v-else-if="getPrice(p, 'RENT')">
                    <span class="price">
                      Thuê: {{ formatPrice(getPrice(p, "RENT")) }}
                    </span>
                  </template>

                  <template v-else>
                    <div class="contact-price">Liên hệ</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT: FORM -->
      <div class="col-12 col-md-4">
        <!-- BASIC INFO -->
        <div class="card p-3 mb-3">
          <input v-model="form.name" placeholder="Tên sản phẩm" class="form-control mb-2" />

          <select v-model="form.type" class="form-control mb-2">
            <option value="SINGLE">SINGLE</option>
            <option value="COMBO">COMBO</option>
          </select>

          <textarea v-model="form.description" class="form-control mb-2" placeholder="Mô tả"></textarea>

          <input v-model="form.imgs" placeholder="Link ảnh ; cách nhau" class="form-control" />
        </div>

        <!-- PRICE -->
        <div class="card p-3 mb-3">
          <h5>Giá sản phẩm</h5>

          <div v-for="(p, i) in form.prices" :key="i" class="border p-2 mb-2">
            <select v-model="p.priceType" class="form-control mb-1">
              <option value="BUY">Mua</option>
              <option value="RENT">Thuê</option>
            </select>

            <input v-model="p.priceValue" type="number" class="form-control mb-1" />

            <input
              v-if="p.priceType === 'RENT'"
              v-model="p.billingCycle"
              class="form-control mb-1"
              placeholder="MONTH"
            />

            <label>
              <input type="checkbox" v-model="p.pilot" />
              Giá thí điểm
            </label>

            <button @click="removePrice(i)" class="btn btn-danger btn-sm mt-1">
              Xóa
            </button>
          </div>

          <button @click="addPrice" class="btn btn-primary btn-sm">+ Thêm giá</button>
        </div>

        <!-- DISCOUNT -->
        <div class="card p-3 mb-3">
          <h5>Chiết khấu</h5>

          <div v-for="(d, i) in form.discount" :key="i" class="border p-2 mb-2">
            <input v-model="d.minQty" type="number" placeholder="Min" class="form-control mb-1" />
            <input v-model="d.maxQty" type="number" placeholder="Max" class="form-control mb-1" />
            <input v-model="d.discountPercent" type="number" placeholder="% giảm" class="form-control mb-1" />

            <button @click="removeDiscount(i)" class="btn btn-danger btn-sm">Xóa</button>
          </div>

          <button @click="addDiscount" class="btn btn-primary btn-sm">+ Thêm</button>
        </div>

        <!-- COMBO -->
        <div v-if="form.type === 'COMBO'" class="card p-3 mb-3">
          <h5>Combo Items</h5>

          <div v-for="(c, i) in form.comboItems" :key="i" class="border p-2 mb-2">
            <input v-model="c.productId" class="form-control mb-1" placeholder="Product ID" />
            <input v-model="c.quantity" type="number" class="form-control mb-1" />

            <button @click="removeCombo(i)" class="btn btn-danger btn-sm">Xóa</button>
          </div>

          <button @click="addCombo" class="btn btn-primary btn-sm">+ Thêm</button>
        </div>

        <!-- SUBMIT -->
        <button @click="submit" class="btn btn-success w-100">
          {{ isEdit ? "Cập nhật sản phẩm" : "Tạo sản phẩm" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { postListSanPham } from "@/components/VimassCrop";
import { KEY_SESSION_ID } from "@/components/listService";
import { MD5 } from "crypto-js";
import axios from "axios";

export default {
  data() {
    return {
      products: [],
      keyword: "",
      isPilot: true,

      isEdit: false,
      editingId: null,

      form: {
        name: "",
        type: "SINGLE",
        description: "",
        imgs: "",
        prices: [],
        discount: [],
        comboItems: []
      }
    };
  },

  computed: {
    filteredProducts() {
      return this.products;
    }
  },

  mounted() {
    this.getDanhSachSanPham();
  },

  methods: {
    async getDanhSachSanPham() {
      let res = await postListSanPham(100, 0, "0979951954", localStorage.getItem(KEY_SESSION_ID), 0);
      console.log("  res?.result ",  res?.result);
      
      this.products = res?.result || [];
    },

    openDetail(p) {
      this.isEdit = true;
      this.editingId = p.id;

      this.form = {
        name: p.name || "",
        type: p.type || "SINGLE",
        description: p.description || "",
        imgs: p.imgs || "",
        prices: (p.prices || []).map(x => ({ ...x })),
        discount: (p.discount || []).map(d => ({ ...d })),
        comboItems: (p.comboItems || []).map(c => ({ ...c }))
      };

      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    addPrice() {
      this.form.prices.push({ priceType: "BUY", priceValue: 0, billingCycle: "MONTH", pilot: false });
    },

    removePrice(i) {
      this.form.prices.splice(i, 1);
    },

    addDiscount() {
      this.form.discount.push({ minQty: 1, maxQty: -1, discountPercent: 0 });
    },

    removeDiscount(i) {
      this.form.discount.splice(i, 1);
    },

    addCombo() {
      this.form.comboItems.push({ productId: "", quantity: 1 });
    },

    removeCombo(i) {
      this.form.comboItems.splice(i, 1);
    },

   submit() {
  if (!this.form.name) {
    alert("Nhập tên sản phẩm");
    return;
  }

  const isUpdate = this.isEdit;

  const funcId = isUpdate ? 2 : 1; // 👈 QUAN TRỌNG
  const typeLogin = 0;
  const timeRequest = Date.now();

  const sessionLogin = localStorage.getItem(KEY_SESSION_ID);
  const idLogin = "0979951954";

  const imgsLength = (this.form.imgs || "").length;
  const discountSize = (this.form.discount || []).length;
  const pricesSize = (this.form.prices || []).length;
  const descriptionLength = (this.form.description || "").length;
  const comboSize = (this.form.comboItems || []).length;
let cksInput = "";

if (isUpdate) {
  cksInput = MD5(
     this.editingId+
    "08CKK@@)$((99r79f" +
    
      sessionLogin +
      idLogin +
      typeLogin +
      timeRequest +
      funcId +
      String(imgsLength) +
      String(discountSize) +
      String(pricesSize) +
      String(descriptionLength) +
      String(comboSize) 
  ).toString();
} else {
  cksInput = MD5(
    "08CKK@@)$((99r79f" +
      sessionLogin +
      idLogin +
      typeLogin +
      timeRequest +
      funcId +
      String(imgsLength) +
      String(discountSize) +
      String(pricesSize) +
      String(descriptionLength) +
      String(comboSize)
  ).toString();
}

  // 👉 clean prices
  const cleanPrices = this.form.prices.map((p) => {
    let item = {
      priceType: p.priceType,
      priceValue: p.priceValue,
      pilot: p.pilot,
    };

    if (p.priceType === "RENT") {
      item.billingCycle = p.billingCycle || "MONTH";
    }

    return item;
  });

  const payload = {
    funcId,
    timeRequest,
    sessionLogin,
    idLogin,
    typeLogin,
    cksInput,

    ...this.form,
    prices: cleanPrices,
  };

  // 👉 thêm ID nếu update
  if (isUpdate) {
    payload.id = this.editingId;
  }

  console.log("🚀 PAYLOAD:", payload);

  axios
    .post(
      "https://web.vimass.vn/VMServicesTest/services/device/requestCommand",
      payload
    )
    .then((res) => {
      if (res.data.msgCode === 1) {
        alert(isUpdate ? "✅ Cập nhật thành công" : "✅ Tạo thành công");

        // reset
        this.isEdit = false;
        this.editingId = null;

        // this.form = {
        //   name: "",
        //   type: "SINGLE",
        //   description: "",
        //   imgs: "",
        //   prices: [],
        //   discount: [],
        //   comboItems: [],
        // };

        this.getDanhSachSanPham();
      } else {
        alert("❌ " + res.data.msgContent);
      }
    });
},

    

     getImages(p) {
            if (!p.imgs) return [];
            return p.imgs.split(";").filter(i => i);
        },

    getPrice(p, type) {
      let item = (p.prices || []).find(x => x.priceType === type && x.pilot === this.isPilot);
      return item ? item.priceValue : 0;
    },

    formatPrice(v) {
      if (!v) return "0";
      return v.toLocaleString("vi-VN");
    },

    onImgError(e) {
      e.target.src = "";
    }
  }
};
</script>

<style scoped>
.pd-product {
  padding: 0 20px;
}

/* PRODUCT */
.product-box {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  transition: 0.2s;
}

.product-box:hover {
  border-color: #086dac;
  transform: translateY(-3px);
}

/* IMAGE */
.img-box {
  aspect-ratio: 1/1;
  background: #fafafa;
  border-radius: 10px;
  overflow: hidden;
}

.img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* NAME */
.product-name {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin: 6px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* PRICE */
.price-box {
  text-align: center;
}

.price {
  color: #ff424e;
  font-weight: 700;
  font-size: 13px;
}

.old-price {
  margin-left: 6px;
  color: #1449d8;
  font-weight: 700;
  font-size: 13px;
}

.contact-price {
  color: #999;
  font-size: 13px;
}

/* PILOT LABEL */
.pilot-label {
  margin-top: 5px;
  text-align: center;
  font-size: 12px;
  color: red;
}
/* ===== CONTAINER ===== */
.col-12.col-md-4 {
  max-width: 420px;
}

/* ===== CARD ===== */
.card {
  border: none;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  background: #fff;
  transition: all 0.2s ease;
  flex-direction: column;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.card h5 {
  font-weight: 700;
  margin-bottom: 12px;
  color: #222;
}

/* ===== INPUT ===== */
.form-control {
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 10px 12px;
  font-size: 14px;
  transition: all 0.2s;
}

.form-control:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

/* ===== SELECT ===== */
select.form-control {
  cursor: pointer;
}

/* ===== TEXTAREA ===== */
textarea.form-control {
  min-height: 80px;
  resize: none;
}

/* ===== ITEM BOX ===== */
.border {
  border: 1px solid #f1f5f9 !important;
  border-radius: 10px;
  background: #fafafa;
  transition: 0.2s;
}

.border:hover {
  background: #f5f7ff;
}

/* ===== BUTTON ===== */
.btn {
  border-radius: 10px;
  font-weight: 600;
  padding: 6px 12px;
  transition: all 0.2s;
}

/* primary */
.btn-primary {
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  border: none;
}

.btn-primary:hover {
  transform: scale(1.03);
}

/* danger */
.btn-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  border: none;
}

.btn-danger:hover {
  transform: scale(1.03);
}

/* submit */
.btn-success {
  background: linear-gradient(135deg, #10b981, #059669);
  border: none;
  font-size: 16px;
  padding: 10px;
}

.btn-success:hover {
  transform: scale(1.02);
}

/* ===== CHECKBOX MODERN ===== */
input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #4f46e5;
  cursor: pointer;
}

/* ===== LABEL ===== */
label {
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ===== SPACING ===== */
.mb-2 {
  margin-bottom: 10px !important;
}

.mb-3 {
  margin-bottom: 16px !important;
}

/* ===== SCROLL (nếu dài) ===== */
.col-12.col-md-4 {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 6px;
}

/* ===== SCROLLBAR ===== */
.col-12.col-md-4::-webkit-scrollbar {
  width: 6px;
}

.col-12.col-md-4::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 10px;
}
</style>
